// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';
import {getDefaultState} from '../state';

const updateShowNoResultsFound = (state, action) => action.hasNoResult;

export default (state = getDefaultState().showNoResultsFound, action) => {

    const actionTypes = {
        [actions.UPDATE_PIP_HISTORY_REPORT_SHOW_NO_RESULTS_FOUND]: updateShowNoResultsFound
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/pip-history/reducers/show-no-results-found.js